export var DrmType;
(function (DrmType) {
    DrmType["None"] = "NONE";
    DrmType["PlayReady"] = "PLAYREADY";
    DrmType["Fairplay"] = "FPS";
    DrmType["Marlin"] = "MS3";
    DrmType["Widevine"] = "WIDEVINE";
})(DrmType || (DrmType = {}));
//# sourceMappingURL=drm.js.map